
import { first, take, takeUntil } from 'rxjs/operators';
import { OnInit, Component, Input, OnDestroy, Output, EventEmitter } from "@angular/core";
import { Notification } from "../../../models/notification/notification.interface";
import { NotificationService } from "../../../services/notification.service";
import { SharedActions } from "../../../shared.actions";
import { ToActions } from "../../../../to-screen/to.actions";
import { SelectionEnum } from "../../../models/selection.enum";
import { TranslateService } from "@ngx-translate/core";
import { select } from '@angular-redux/store';
import { ApplicationUser } from '../../../../pb-screen/models/application.user.interface';
import { Observable, Subject } from 'rxjs-compat';
import { PlanningBlock } from "../../../../pb-screen/models/planning-block/planning-block.interface";
import { OrderLine } from "../../../../pb-screen/models/order-line/orderLine.interface";
import { SharedService } from "../../../services/shared.service";
import { UserFeedbackService } from "../../../../services/user-feedback.service";



@Component({
  selector: "notification-viewer",
  templateUrl: "./notification-viewer.component.html"
})
export class NotificationViewerComponent implements OnInit, OnDestroy {

    @select('applicationUser') public applicationUser$: Observable<ApplicationUser>;
    @select('selectedPlanningBlocks') private readonly selectedPlanningBlocks$: Observable<PlanningBlock[]>;
    @select('selectedOrderlines') private readonly selectedOrderlines$ : Observable<OrderLine[]>;
    public enableAutocomplete: boolean = false;
    private _notifications = [];
    private selectedPlanningBlocks: PlanningBlock[] = [];
    orderLines: OrderLine[] = [];
    SelectionEnum = SelectionEnum;

    get Notifications(): Notification[] {
        return this._notifications;
    }

  @Input()
  set Notifications(val: Notification[]) {
    this._notifications = val;
    this.checkedNotifications = this.checkedNotifications.filter(el => val.findIndex(value => value == el) != -1);
  }

  @Input() SelectedNotification: Notification;
  @Input() selectionType: SelectionEnum;

    @Output() selectedNotifications = new EventEmitter<Notification[]>();

    private index : Number = 0;
    private selectedNotification : Notification;
    public  checkedNotifications: Notification[] = [];
    destroy$ = new Subject();

    constructor(
        private readonly notificationService: NotificationService,
        public readonly sharedActions: SharedActions,
        public readonly toActions: ToActions,
        public readonly translate: TranslateService,
        private readonly sharedService: SharedService,
        private readonly userFeedbackService: UserFeedbackService

    ) {
    }

    ngOnInit(): void {
        this.applicationUser$.pipe(takeUntil(this.destroy$)).subscribe((applicationUser: ApplicationUser) => {
                          if (applicationUser) {
                            this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
                          }
                        });

        this.selectedPlanningBlocks$.pipe(take(1)).subscribe((selection: PlanningBlock[]) => {
             if (selection && selection.length > 0) {
                this.selectedPlanningBlocks = selection;
                 this.sharedService.getOrderLines(selection.map(pb => pb.id).join(","))
                   .pipe(take(1))
                   .subscribe((orderlines: OrderLine[]) => {
                       this.orderLines = orderlines;
                   });
            }
        });
    }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public SelectNotification(id) {
    this.SelectedNotification = this.Notifications.filter(x => x.id == id)[0];
  }

    notificationSelected(notification, event) {
        var index = this.checkedNotifications.findIndex(el => el.id == notification.id);
        if(index == -1)
            this.checkedNotifications.push(notification);
        else
            this.checkedNotifications.splice(index, 1);

        this.selectedNotifications.emit(this.checkedNotifications);
    }

    getNotificationText(notification: Notification) {
        if (notification.lineNumber === 0) {
            return `${this.selectedPlanningBlocks[0].info}`;
        }

        const matchingOrderline = this.orderLines.find((ol: OrderLine) => notification.lineNumber === ol.lineNumber);

        if (matchingOrderline) {
            return `${matchingOrderline.actionNumber} - ${matchingOrderline.addressSearchName}`;
        }

        return "";
    }

    processNotifications() {
    var ids = this.checkedNotifications.map(el => el.id).join(",");
    if (this.selectionType === SelectionEnum.PlanningBlock) {
      this.notificationService.processNotificationsForPb(ids, this.checkedNotifications[0].planningBlockId).subscribe(result => {
          this.sharedActions.updatePlanningBlocksDisplay([result]);
          this.setNotificationsAsProcessed();
        }, _ => {
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.NOTIFICATION_PROCESSED_ERROR");
        }
      );
    } else if (this.selectionType === SelectionEnum.TransportOrder) {
      this.notificationService.processNotificationsForTo(ids, this.checkedNotifications[0].transportOrderNumber).subscribe(result => {
          this.toActions.setSelectedTransportOrders([result]);
          this.toActions.updateTransportOrdersDisplay([result]);
          this.setNotificationsAsProcessed();
        }, _ => {
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.NOTIFICATION_PROCESSED_ERROR");
        }
      );
    }
  }

  setNotificationsAsProcessed() {
    this.checkedNotifications.forEach(el => el.processed = true);
    this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.NOTIFICATION_PROCESSED_SUCCESS");
  }
}
